import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext.ts";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { connection } from "utils/apiConnection.ts";
import Loader from "utils/Loader";

// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  id: any;
  token: string;
  fullName: string;
  mobile: string;
  shopIds: number[];
  ccShopIds: number[];
}
export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const [userInfo, setUserInfo] = useState<UserInformation>({
    id: 0,
    token: "",
    fullName: "",
    mobile: "",
    shopIds: [],
    ccShopIds: [],
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);

  const [isChecked, setIsChecked] = useState<boolean>(false);


  useEffect( () => {
     checkCookie();
  }, []);

  function login(token: string, info: any): void {
    setIsLogged(true);
    setUserInfo({
      token,
      fullName: info.fullname,
      mobile: info.mobile,
      id: info.id,
      shopIds: info.shopIds,
      ccShopIds: info.ccShopIds,
    });

    Cookies.set("token", token);
  }

  async function logout(): Promise<void> {
    let result = await connection("logout", {});
    if (result.status == 1) {
      setIsLogged(false);
      setUserInfo({
        id: 0,
        token: result.data.usertoken,
        fullName: "",
        mobile: "",
        shopIds: [],
        ccShopIds: [],
      });
      Cookies.set("token", result.data.usertoken);
    } else {
      toast.error(
        "خارج شدن از سیستم با مشکل مواجه شده است، لطفا بعدا امتحان کنید."
      );
    }
  }

  async function checkCookie(): Promise<void> {
    let result = await connection("checklogininfo");
    if (result.status == 1) {
      setIsLogged(result.userinfo.id != -1);
      setUserInfo({
        id: result.userinfo.id,
        token: result.data.usertoken,
        mobile: result.userinfo.mobile,
        fullName: result.userinfo.fullname,
        shopIds: result.userinfo.shopIds,
        ccShopIds: result.userinfo.ccShopIds,
      });
      Cookies.set("token", result.data.usertoken);
    } else if (!Cookies.get("token")) {
      Cookies.set("token", result.data.usertoken);
    }

    setIsChecked(true);

  }

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          userInfo,
          isLogged,
          setUserInfo,
          login,
          logout,
        }}
      >
        {isChecked ? children : <Loader />}
      </AuthenticationContext.Provider>
    </>
  );
}
